// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"scCSh","field":"IKXv0","description":"sq_kq","excludedCountriesButton":"Pn1w1","excludedCountriesIcon":"NdgxX"};